export default __webpack_public_path__ + "static/media/mango-colored.cc890b9b.webp";